import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { IComplementQuery, INodeNavigationResponse } from '@types'

const FIND_NODE_COMPLEMENTS_QUERY = gql`
  query Query($id: ID!) {
    findNodeNavigation(id: $id) {
      type
      payload {
        ... on NodeNavigationResponse {
          nodeNavigation {
            id
            title
            type
            sub_type
            complement {
              title
              description
              external_nodes {
                title
                type
              }
            }
          }
        }
      }
    }
  }
`

export const useComplementQuery = (variables: IComplementQuery) => {
  const query = useQuery<INodeNavigationResponse>(FIND_NODE_COMPLEMENTS_QUERY, variables, {
    fetchPolicy: 'cache-first'
  })
  return query
}
